import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi } from "@/lib/toast";
import { chatApi } from "@/features/autorizacion/services/chat.api";

/**
 * Lee la lista del chat con polling de 3s. La key compartida con la
 * mutation permite que `setQueryData` post-envío hidrate al instante.
 *
 * Usado por `<ChatCard>` (lista completa) y por el badge "N mensajes"
 * en los tabs del detalle.
 */
export function useChatMensajes(solicitudId: string, enabled: boolean) {
  return useQuery({
    queryKey: qk.chat(solicitudId),
    queryFn: () => chatApi.listar(solicitudId),
    enabled,
    refetchInterval: 3_000,
  });
}

/**
 * Envía un mensaje al chat de la solicitud · invalida la lista al
 * éxito (el polling se encargaría también, pero esto evita el delay
 * de 3 s antes de ver el mensaje propio).
 */
export function useEnviarMensajeChat(
  solicitudId: string,
  opts?: { onEnviado?: () => void }
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (texto: string) => chatApi.enviar(solicitudId, texto),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: qk.chat(solicitudId) });
      opts?.onEnviado?.();
    },
    onError: toastErrorApi,
  });
}
